/**
 * Add connection component save, update and clone connection to database as well upload content images and hero image to s3 bucket.
 */

import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { NavLink } from "react-router-dom";
import * as placesActions from "../../../store/admin";
import * as _ from "lodash";
import { Groups } from "../../admin";
import { NotificationManager } from "react-notifications";
import "react-datepicker/dist/react-datepicker.css";
import { config } from "../../../config/config";
import "react-notifications/lib/notifications.css";
import { BackStrip, Header } from "../../../common/layout";
import { utilPostService, utilService } from "../../../common/utils";
import { deviceDetect } from "react-device-detect";
import { placeReducer } from '../../../store/admin';
import * as keyLearningAreaActions from '../../../store/portal';
import * as adminActions from '../../../store/admin';

// CKEditor.stylesSet.add('my_styles', [
//   // Block-level styles
//   { name: 'Blue Title', element: 'h2', styles: { 'color': 'Blue' } },
//   { name: 'Red Title', element: 'h3', styles: { 'color': 'Red' } },

//   // Inline styles
//   { name: 'CSS Style', element: 'span', attributes: { 'class': 'my_style' } },
//   { name: 'Marker: Yellow', element: 'span', styles: { 'background-color': 'Yellow' } }
// ])

class AddPlace extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.subscriptions = [];
    this.state = {
      editors: "",
      groups: [],
      placeData: {
        group_list: {
          groups: [],
          groupNames: [],
        },
        key_learning_area: "",
        klaUid: "",
        place_id: "",
      },
      isLoading: false,
      isSaving: false,
      errors: {},
      key_learning_area: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onGroupsChange = this.onGroupsChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    // google analytic page view
    utilService.pageView();

    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "add-place",
      title: "Add Place",
      browserName: browserName,
      osName: osName,
      pageType: "Add Place Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });

    const id = this.props.match.params.id;
    if (id) {
      // fetch post based on postUid
      this.props.fetchPlace({
        id: this.props.match.params.id,
        token: this.props.token,
      });
    }
    this.props.fetchKeyLearningAreas({
      token: this.props.token,
      params: '',
    });
    // Fetch groups
    this.props.fetchGroups(this.props.token);
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs in state and props
   * @param {*} prevProps
   */
  componentDidUpdate(prevProps, prevState) {
    if (this.state.isSaving) {
      if (prevProps.placeActionLoading && !this.props.placeActionLoading) {
        this.setState(
          {
            errors: {},
            isLoading: false,
            isSaving: false,
          },
          function () {
            NotificationManager.success(
              "Success message",
              "Place saved successfully."
            );
            this.props.history.push("/admin");
          }
        );
      }
    }
  }

  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.place) {
      if (nextProps.place !== this.props.place) {
        let placeJson = nextProps.place;
        this.setState({
          ...this.state,
          editors: placeJson["editors"].join(),
          placeData: placeJson,
        });
      }
    }
  }

  /**
   * Handle input change event
   * @param {*} e
   */
  handleInputChange(e) {
    const { name, value } = e.target;
    let fields = this.state.placeData;
    if (name === "editors") {
      this.setState({
        editors: value,
      });
    } else {
      if (name === "place") {
        let slug = value.trim();
        slug = slug.toLowerCase();
        slug = slug.split(" ");
        slug = slug.filter((e) => e !== "");
        slug = slug.join("-");
        fields["slug"] = slug;
      }
      fields[name] = value;
      this.setState({
        fields,
      });
    }
  }

  /**
   * Validate form field before sumbmitting
   */
  validateForm() {
    let fields = this.state.placeData;

    let errors = {};
    let formIsValid = true;

    if (fields["place_id"]) {
      if (isNaN(fields["place_id"])) {
        formIsValid = false;
        errors["place_id"] = '*Please enter only numeric value.';
      }
    }
    if (!fields["place"]) {
      formIsValid = false;
      errors["place"] = "*Please enter place.";
    }
    if (!fields["slug"]) {
      formIsValid = false;
      errors["slug"] = "*Please enter slug.";
    }
    if (!fields["description"]) {
      formIsValid = false;
      errors["description"] = "*Please enter description.";
    }
    if (!fields["intended_audience"]) {
      formIsValid = false;
      errors["intended_audience"] = "*Please enter intended audience.";
    }
    if (!this.state["editors"]) {
      formIsValid = false;
      errors["editors"] = "*Please enter editors.";
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  handleChange(e) {
    let data = this.props.keyLearningAreas && this.props.keyLearningAreas.find((item) => item.klaUid === e.target.value)
    if (data) {
      this.setState({
        placeData: {
          ...this.state.placeData,
          key_learning_area: data.key_learning_area,
          klaUid: data.klaUid
        },
        key_learning_area: e.target.value
      })
    }
    else {
      this.setState({
        placeData: {
          ...this.state.placeData,
          key_learning_area: "",
          klaUid: ""
        },
        key_learning_area: ""
      })
    }
  }
  /**
   * Set post groups
   * @param {*} e
   */
  onGroupsChange(e) {
    let fields = this.state.placeData;
    if (e.target.checked) {
      let gobj = _.find(this.props.groups, { groupUid: e.target.value });
      if (gobj) {
        this.setState({
          ...this.state,
          placeData: {
            ...this.state.placeData,
            group_list: {
              ...this.state.placeData.group_list,
              groups: [...this.state.placeData.group_list.groups, gobj],
              groupNames: [
                ...this.state.placeData.group_list.groupNames,
                gobj.groupname,
              ],
            },
          },
        });
      }
    } else {
      let gobj = _.find(fields.group_list.groups, { groupUid: e.target.value });
      if (gobj) {
        let grops = _.remove(fields.group_list.groups, function (o) {
          return o.groupUid === e.target.value;
        });
        _.remove(fields.group_list.groupNames, function (o) {
          return o === gobj.groupname;
        });
        this.setState({
          fields,
        });
      }
    }
  }
  /**
   * Save place details
   * @param {]} e
   */
  onSubmit(e) {
    e.preventDefault();
    // validate form before save into database
    if (this.validateForm()) {
      let fields = this.state.placeData;
      // convert editors field  to list
      if (this.state.editors) {
        let editors = this.state.editors.trim();
        editors = editors.split(",");
        fields["editors"] = editors;
      }
      // Save groupNamesSearch field into database to search groups by keyword
      if (
        fields["group_list"]["groupNames"] &&
        fields["group_list"]["groupNames"].length > 0
      ) {
        fields["group_list"]["groupNamesSearch"] = fields["group_list"][
          "groupNames"
        ].toString();
        fields["group_list"]["groupNamesSearch"] = fields["group_list"][
          "groupNamesSearch"
        ].toLowerCase();
      }
      fields["updated_at"] = new Date();
      if (!this.state.placeData.placeUid) {
        fields["created_at"] = new Date();
      } else {
        if (!fields["created_at"]) {
          fields["created_at"] = new Date();
        }
      }
      fields["users_userid"] = this.props.user.userUid;
      fields["users_username"] = this.props.user.username;
      fields["users_firstname"] = this.props.user.firstname;
      fields["users_lastname"] = this.props.user.surname;

      // Update fields
      this.setState({
        fields,
        isLoading: true,
        isSaving: true,
      });
      if (this.state.placeData.placeUid) {
        this.props.updatePlace({
          token: this.props.token,
          data: this.state.placeData,
        });
      } else {
        this.props.savePlace({
          token: this.props.token,
          data: this.state.placeData,
        });
      }
    }
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    const { groups } = this.state.placeData.group_list;

    return (
      <div>
        <BackStrip nav="/admin" isFilter="false" />
        <div className="position-relative">
          <div id="content">
            <Header cname="admin-home" text="Add Place" />
            <main className="admin-home">
              <div className="container" style={{ maxWidth: "95%" }}>
                <div className="row justify-content-end brd-btm">
                  <ul
                    className="nav nav-pills d-flex justify-content-center"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <NavLink className="nav-link active" to="/admin">
                        Admin Home
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-toggle="pill"
                        href="#archived"
                      >
                        Places
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
                  <h1>CREATE PLACE</h1>
                </div>
                <div className="row">
                  <div className="col-md-4 bg-offlight reps-m-2">
                    <div className="radioslide">
                      <Groups
                        groups={this.props.groups}
                        selectedGroupList={groups}
                        onGroupsChange={this.onGroupsChange}
                      />
                    </div>
                    <div>
                      <h2 className="selected-group-title">Selected Groups</h2>
                      <div className="selected-group">
                        {this.state.placeData.group_list.groups &&
                          this.state.placeData.group_list.groups.map(
                            (item, index) =>
                              item.groupname +
                              (this.state.placeData.group_list.groups.length -
                                1 !==
                              index
                                ? ","
                                : "")
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <form ref={(el) => (this.myFormRef = el)} name="addPost">
                      <div className="filters">
                        <div className="row">
                          <div className="col-lg-8 col-xl-8">
                            <div className="d-block align-items-center mt-2">
                              <label className="title-label">Key Learning Area</label>
                              <select
                                className="form-control"
                                name="key_learning_area"
                                onChange={this.handleChange}
                                value={this.state.placeData.klaUid || ''}
                              >
                                <option key="" value="">No KLA</option>
                                {this.props.keyLearningAreas &&
                                  this.props.keyLearningAreas.map((item, index) => (
                                    <option key={item.klaUid} value={item.klaUid}>
                                      {item.key_learning_area}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3 col-xl-3">
                            <div className="d-block align-items-center mt-2">
                              <label className="title-label">PLACE ID</label>
                              <input
                                type="text"
                                name="place_id"
                                className="form-control"
                                placeholder="Enter Place ID"
                                title="Normally managed by our sync from Edumate.course.previous_course_id into DynamoDB.place.place_id, we use this to map classes that continue across academic years."
                                onChange={this.handleInputChange}
                                value={this.state.placeData.place_id || ''}
                              />
                              <div className="errorMsg">
                                {this.state.errors['place_id']}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-xl-6">
                            <div className="d-block align-items-center mt-2">
                              <label className="title-label">Place</label>
                              <input
                                type="text"
                                name="place"
                                className="form-control"
                                placeholder="Enter Place"
                                onChange={this.handleInputChange}
                                value={this.state.placeData.place || ""}
                              />
                              <div className="errorMsg">
                                {this.state.errors["place"]}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-xl-6">
                            <div className="d-block align-items-center mt-2">
                              <label className="title-label">Slug</label>
                              <input
                                type="text"
                                readOnly
                                name="slug"
                                className="form-control"
                                placeholder="Enter Slug"
                                onChange={this.handleInputChange}
                                value={this.state.placeData.slug || ""}
                              />
                              <div className="errorMsg">
                                {this.state.errors["slug"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 pt-1">
                            <div className="d-block">
                              <label className="title-label">Description</label>
                              <textarea
                                name="description"
                                rows="8"
                                onChange={this.handleInputChange}
                                value={this.state.placeData.description || ""}
                              ></textarea>
                              <div className="errorMsg">
                                {this.state.errors["description"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 pt-1">
                            <div className="d-block">
                              <label className="title-label">
                                Intended Audience
                              </label>
                              <textarea
                                name="intended_audience"
                                rows="8"
                                onChange={this.handleInputChange}
                                value={
                                  this.state.placeData.intended_audience || ""
                                }
                              ></textarea>
                              <div className="errorMsg">
                                {this.state.errors["intended_audience"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 pt-1">
                            <div className="d-block">
                              <label className="title-label">Editors</label>
                              <input
                                type="text"
                                name="editors"
                                className="form-control"
                                placeholder="Enter comma separated editors name without space"
                                onChange={this.handleInputChange}
                                value={this.state.editors || ""}
                              />
                              <div className="errorMsg">
                                {this.state.errors["editors"]}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end pt-3">
                        {this.state.isSaving && (
                          <button
                            disabled={this.state.isLoading}
                            className="bg-primary filter-btn"
                            onClick={this.onSubmit.bind(this)}
                          >
                            save ...
                          </button>
                        )}

                        {!this.state.isSaving && (
                          <button
                            disabled={this.state.isLoading}
                            className="bg-primary filter-btn"
                            onClick={this.onSubmit.bind(this)}
                          >
                            save
                          </button>
                        )}
                        <NavLink to="/admin/">
                          <button className="bg-dark filter-btn">cancel</button>
                        </NavLink>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state, props) {
  const id = props.match.params.id;
  return {
    placeActionLoading: state.places.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    keyLearningAreas: Object.values(state.keyLearningArea.byId),
    groups: Object.values(state.groups.byId),
    place: id ? state.places.byId[id] : "",
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(
    Object.assign({}, keyLearningAreaActions, placesActions),
    dispatch
  )
)(AddPlace);
